// Tracks page views and document title updates from route state.

import { useEffect } from 'react';
import { analyticsService } from '../services/analyticsService';
import type { AnalyticsAudience } from '../types/analytics';
import { useAuth } from './useAuth';
import { useRoute } from './useRoute';

export const useAnalyticsPageTracker = () => {
  const { pageTitle, normalizedPath, roomCode } = useRoute();
  const { user } = useAuth();

  useEffect(() => {
    document.title = pageTitle;

    let analyticsAudience: AnalyticsAudience | undefined;
    if (user) {
      analyticsAudience = 'user';
    } else if (typeof window !== 'undefined') {
      const isPlayer = sessionStorage.getItem('ga_player_status') === 'true';
      if (isPlayer) {
        analyticsAudience = 'player';
      }
    }

    analyticsService.trackPageView(normalizedPath, pageTitle, {
      ...(roomCode && { room_code: roomCode }),
      ...(analyticsAudience && { analytics_audience: analyticsAudience }),
    });
  }, [pageTitle, normalizedPath, roomCode, user]);
};
